import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import pt from "./pt.json";

Vue.use(VueI18n)

const i18n = new VueI18n({
  fallbackLocale: "en",
  locale: localStorage.getItem("locale") || "en",
  messages: {
    en,
    de,
    fr,
    es,
    pt,
  }
})

export default i18n